import { render, staticRenderFns } from "./templateConfig.vue?vue&type=template&id=44b74b6b&scoped=true"
import script from "./templateConfig.vue?vue&type=script&lang=js"
export * from "./templateConfig.vue?vue&type=script&lang=js"
import style0 from "./templateConfig.vue?vue&type=style&index=0&id=44b74b6b&prod&lang=css"
import style1 from "./templateConfig.vue?vue&type=style&index=1&id=44b74b6b&prod&scoped=true&lang=css"
import style2 from "./templateConfig.vue?vue&type=style&index=2&id=44b74b6b&prod&lang=css"
import style3 from "./templateConfig.vue?vue&type=style&index=3&id=44b74b6b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b74b6b",
  null
  
)

export default component.exports